<template>
  <div class="plugin-wrap big__text" v-if="config && config.text">
    <div class="quote-section layout">
      <div class="ms-row center-xs">
      <blockquote>
        <div class="col-xs-10 col-sm-12">
          <q class="quote-text">
            <i>{{config.text}}</i>
          </q>
        </div>
        <!-- <div class="quote-author col-xs-12">-Isabelle d'Ornano</div> -->
      </blockquote>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BigText',
  props: {
    config: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .quote-section {
    text-align: center;
    margin: 7rem auto 5rem;
    padding: 0 .9375rem;
    .quote-text {
      font-family: PlayfairDisplay-Regular,arial,sans-serif;
      font-size: 2.8125rem;
      line-height: 1;
      color: #000;
      position: relative;
      i { font-family: PlayfairDisplay-Italic,arial,sans-serif; font-style: normal; }
      &::before {
        content: "“";
        position: absolute;
        left: -1.75rem;
        top: -0.625rem;
        font-size: 5.625rem;
        line-height: 0.4;
      }
      &::after {
        content: "„";
        position: absolute;
        right: -2.0625rem;
        bottom: 2.1875rem;
        font-size: 5.625rem;
        line-height: 0.4;
      }
    }
    .quote-author {
      margin-top: 1.25rem;
      letter-spacing: .04688rem;
      font-size: .8125rem;
      line-height: 1;
      font-weight: 600;
      color: #000;
    }
  }
  @media screen and (min-width: 48em) {
    .quote-section {
      padding: 0 3rem;
      .quote-text {
        font-size: 5rem;
        &:before {
          left: -2.5rem;
          top: 1.125rem;
        }
        &:after {
          right: -2.5rem;
          bottom: 2.8125rem;
        }
      }
      .quote-author {
        font-size: 1.25rem;
        letter-spacing: .0625rem;
        margin-top: 2.625rem;
      }
    }
  }
  @media screen and (min-width: 64em) {
    .quote-section {
      padding: 0 1.875rem;
    }
  }
  @media screen and (min-width: 75em) {
    .quote-section {
      padding: 0;
      margin: 8.375rem auto 3.625rem;
      .quote-text {
        font-size: 7.8125rem;
      }
      .quote-author {
        margin-top: 3.625rem;
      }
    }
  }
</style>